import { Outlet } from 'react-router';
import { ReactNode } from 'react';
import { Card } from '../../components/ui';

interface AuthLayoutProps {
  children?: ReactNode;
  title?: string;
  subtitle?: string;
}

export function AuthLayout({ children, title, subtitle }: AuthLayoutProps = {}) {
  return (
    <div className="min-h-screen bg-gradient-to-br from-alice-blue-300 to-lavender-web-300 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        {/* Logo */}
        <div className="flex justify-center mb-8">
          <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-primary text-primary-foreground text-xl font-bold shadow-lg hover-scale">
            N
          </div>
        </div>
        
        {/* Title and subtitle */}
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold tracking-tight text-foreground">
            {title || 'Welcome back'}
          </h1>
          {subtitle && (
            <p className="mt-3 text-lg text-muted-foreground">
              {subtitle}
            </p>
          )}
        </div>
      </div>

      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <Card className="shadow-xl">
          <div className="p-8">
            {children || <Outlet />}
          </div>
        </Card>
      </div>
    </div>
  );
}